import { useReporting } from '@/hooks/useReporting';
import useRouteInfo from '@/hooks/useRouteInfo';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';
import { getCurrentScrollPercentage } from '@/utils/scroll';
import { useCallback, useEffect, useRef } from 'react';

export const useBlogMainTrack = () => {
  // const { isAttemptingNavigation, proceedNavigation } = useBlockNavigation(true);
  const { trackEvent } = useReporting();
  const enterTimer = useRef<number>(Date.now());
  const { getFromRouterInfo } = useRouteInfo();
  // 记录最后的滚动状态，避免页面跳转时滚动位置被重置
  const lastScrollState = useRef({ viewAdvance: 0 });
  const pageView = useCallback((_fromRouterInfo: any) => {
    trackEvent(
      {
        eventName: 'BlogPage_View',
        properties: {
          refer_page_name: _fromRouterInfo.refer_page_name,
          refer_url_path: _fromRouterInfo.refer_url_path,
        },
      },
      [ProviderType.SENSORS],
    );
  }, []);

  const pageLeave = useCallback((_fromRouterInfo: any) => {
    const { viewAdvance } = lastScrollState.current;
    const view_duration = Math.ceil((Date.now() - enterTimer.current) / 1000);
    trackEvent(
      {
        eventName: 'BlogPage_Leave',
        properties: {
          refer_page_name: _fromRouterInfo.refer_page_name,
          refer_url_path: _fromRouterInfo.refer_url_path,
          view_advance: viewAdvance,
          view_duration,
        },
      },
      [ProviderType.SENSORS],
    );
  }, []);

  const sdBlogPageMktClick = (params: any, activeNav: any) => {
    const sdEventParams = {
      ...params,
      first_tab_name: activeNav?.parent_name,
      second_tab_name: activeNav?.parent_name === activeNav?.name ? '' : activeNav?.name,
    };
    trackEvent(
      {
        eventName: 'BlogPageMkt_Click',
        properties: sdEventParams,
      },
      [ProviderType.SENSORS],
    );
  };

  const sdBlogPageMktExp = (params: any, activeNav: any) => {
    const sdEventParams = {
      ...params,
    };
    if (params.mkt_name && !params.mkt_name.includes('顶部')) {
      sdEventParams.first_tab_name = activeNav?.parent_name;
      sdEventParams.second_tab_name =
        activeNav?.parent_name === activeNav?.name ? '' : activeNav?.name;
    }
    trackEvent(
      {
        eventName: 'BlogPageMkt_Exp',
        properties: sdEventParams,
      },
      [ProviderType.SENSORS],
    );
  };

  useEffect(() => {
    enterTimer.current = Date.now();
    const { refer_page_name, refer_url_path } = getFromRouterInfo();
    pageView({ refer_page_name, refer_url_path });
    return () => {
      pageLeave({ refer_page_name, refer_url_path });
    };
  }, []);
  // 定期更新滚动状态，避免页面跳转时丢失滚动信息
  useEffect(() => {
    const updateScrollState = () => {
      try {
        const viewAdvance = getCurrentScrollPercentage();
        lastScrollState.current = { viewAdvance };
      } catch (error) {
        // 忽略错误，使用默认值
        logger.error('Error updating scroll state:', error);
      }
    };

    // 立即更新一次
    updateScrollState();

    // 监听滚动事件，实时更新滚动状态
    const handleScroll = () => {
      updateScrollState();
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    sdBlogPageMktClick,
    sdBlogPageMktExp,
    pageView,
    pageLeave,
  };
};
